import React from 'react';

import Avatar from '@atlaskit/avatar';

import { components } from '@qality/common-components/src/atoms/atlaskit/Select';

import { UserPickerAvatarWrapper, UserStyled } from './UserPicker.styled';

export const UserPickerValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <UserStyled>
        <UserPickerAvatarWrapper>
          <Avatar
            size='xsmall'
            src={props.data.avatar}
            borderColor='var(--ds-soldevelo-aureola-border, var( --ds-fb-soldevelo-aureola-border))'
          />
        </UserPickerAvatarWrapper>
        {props.children}
      </UserStyled>
    </components.SingleValue>
  );
};
